<template>
	<c-dialog ref="dialog" title="选择上架渠道" height="70vh" button-name="确定上架">
		<ul class="tab flex">
			<li class="flex-grow" :class="{'z-crt': currentChannel == 2}" @click="currentChannel = 2">靓机渠道</li>
			<li class="flex-grow" :class="{'z-crt': currentChannel == 1}" @click="currentChannel = 1">暗拍渠道</li>
		</ul>
		<!-- 积分不足提示：判定与分数均由服务端下发，H5无积分账户页，只给入口不给充值按钮 -->
		<p v-if="pointsWarning" class="points-tip">{{pointsTip}}</p>
		<!-- 上架改价：未发布渠道可填价随发布生效；已发布渠道上架不改价，售价置灰沿用现价（调价走【改价】功能） -->
		<c-form>
			<c-form-item v-for="(item, i) in channelList" :key="i" :label="item.channel_name">
				<!-- 已发布渠道上架不改价：售价框置灰只读、沿用当前定价，与PC端、后端 onShelf 同口径 -->
				<c-input v-model="item.sale_price" type="number" decimal="2" :range="[0.01, Infinity]" append-text="元" :disabled="item.channel_publish_state == 2"></c-input>
				<p v-if="item.channel_publish_state == 2" class="published-tip">已发布，上架不改价，如需调价请用【改价】功能</p>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				productId: '',
				channelList: [],
				currentChannel: 2,
				/**积分不足提示（服务端按商家账户渠道上架积分与平台配置线判定后下发）*/
				pointsWarning: false,
				/**积分校验线（分），0为平台未配置，不校验不出提示*/
				pointsLine: 0,
				/**积分处置方式（1-拦截上架 2-仅提醒，与PC端、服务端同一取值口径）*/
				pointsMode: 2
			}
		},

		computed: {
			/*********积分提示文案：“不可上架”的用词随服务端开关变，与PC端同一口径**********/
			pointsTip() {
				if (this.pointsMode == 1) {
					return '渠道同售积分已不足' + this.pointsLine + '分，不可上架，请在电脑端【财务 → 上架积分明细】充值';
				}
				return '渠道同售积分不足' + this.pointsLine + '分，可能影响后续销售，请及时在电脑端充值';
			}
		},

		watch: {
			currentChannel() {
				this.update();
			}
		},
		
		methods: {
			open(data) {
				this.productId = data.id;
				this.currentChannel = 2;
				this.update();
				this.$refs.dialog.open({
					resolve: (stop, next) => {
						stop();
						if (this.pointsWarning && this.pointsMode == 1) {
							this.$message({
								message: '渠道同售积分已不足' + this.pointsLine + '分，请先充值再上架'
							});
							return;
						}
						let list = this.channelList.filter(item => item.sale_price > 0);
						if (!list.length) {
							this.$message({
								message: '请填写要上架渠道的价格'
							});
							return;
						}

						this.request({
							url: '/sale/product/onShelf',
							data: {
								product_id: this.productId,
								channel_list: list.map(item => {
									return {
										channel_id: item.channel_id,
										sale_price: item.sale_price
									}
								})
							},
							loading: true,
							success: data => {
								this.$message({
									message: (data && data.price_warn_count > 0) ? '上架成功，其中' + data.price_warn_count + '条售价低于最低控价' : '上架成功'
								});
								next();
								this.$emit('resolve');
							}
						})
					}
				});
			},

			update() {
				this.request({
					url: '/sale/product/shelfChannel/list',
					data: {
						product_id: this.productId,
						channel_type: this.currentChannel
					},
					loading: true,
					success: data => {
						this.pointsWarning = !!data.points_warning;
						this.pointsLine = data.points_line || 0;
						this.pointsMode = data.points_mode || 2;
						this.channelList = data.channel_list;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.points-tip {
		padding: .16rem .3rem;
		font-size: .26rem;
		line-height: 1.4;
		color: #f5222d;
		background: #fff6f6;
	}

	.published-tip {
		margin-top: .08rem;
		font-size: .24rem;
		line-height: 1.4;
		color: #999;
	}

	.tab {
		z-index: 1;
		position: sticky;
		top: 0;
		padding-top: .03rem;
		background: #F2F2F2;

		li {
			line-height: 1rem;
			font-size: .32rem;
			text-align: center;
			color: #444;

			&.z-crt {
				font-size: .36rem;
				font-weight: 600;
				color: #000;
				background: #fff;
			}
		}
	}
</style>